/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import { useTheme } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import _some from "lodash/some";

import AlertsIcon from "./AlertsIcon";
import types from "../../helpers/types";

const getAlertTooltipTitle = (alerts) => {
  let title = "";

  if (alerts.length) {
    if (alerts.length === 1) {
      title = alerts[0].description;
    } else {
      title = (
        <ul style={{ paddingLeft: 16, margin: 0 }}>
          {alerts.map((alert) => (
            <li key={alert.value}>{alert.description}</li>
          ))}
        </ul>
      );
    }
  }

  return title;
};

const getAlertIconColor = (hasPossibleImpactAlert, alerts, theme) => {
  let color = hasPossibleImpactAlert ? theme.palette.grey[500] : null;

  if (_some(alerts, types.alerts.shutdown)) {
    color = theme.palette.primary.red;
  }
  return color;
};

const AlertsIconWithTooltip = ({ alerts, isRouteDetails, ...props }) => {
  const theme = useTheme();
  const hasPossibleImpactAlert =
    alerts.length === 1 &&
    alerts[0].value === types.alerts.possibleImpact.value;

  return (
    <Tooltip title={getAlertTooltipTitle(alerts)}>
      <AlertsIcon
        {...props}
        color={getAlertIconColor(hasPossibleImpactAlert, alerts, theme)}
      />
    </Tooltip>
  );
};

export default AlertsIconWithTooltip;
